import React from 'react';
import PropTypes from 'prop-types';
import GenericCommissioningContent from 'src/screen/Protected/DeviceScreen/Commissioning/GenericCommissioningContent';
import CommissioningCircuitReport from './CommissioningCircuitReport';

export default function CommissioningCircuitContent (props) {
  const { deviceId } = props;

  return (
    <GenericCommissioningContent
      deviceId={deviceId}
      checkSheetType="commissioning-circuit"
      titleKey="commissioningCircuit.title"
      createReportButtonKey="commissioningCircuit.createReport"
      tableId="device-commissioning-circuit-table"
      contentTestId="commissioning-circuit-content"
      fetchTaskType="commissioning-circuit-general"
      ReportComponent={CommissioningCircuitReport}
    />
  );
}

CommissioningCircuitContent.propTypes = {
  deviceId: PropTypes.string,
};

CommissioningCircuitContent.defaultProps = {
  deviceId: null,
};
